var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_3249)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M60 120C93.14 120 120 93.14 120 60C120 26.86 93.14 0 60 0C26.86 0 0 26.86 0 60C0 93.14 26.86 120 60 120Z",
    fill: "#1A1B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 94H35C31.69 94 29 91.31 29 88V32C29 28.69 31.69 26 35 26H85C88.31 26 91 28.69 91 32V88C91 91.31 88.31 94 85 94ZM35 30C33.9 30 33 30.9 33 32V88C33 89.1 33.9 90 35 90H85C86.1 90 87 89.1 87 88V32C87 30.9 86.1 30 85 30H35Z",
    fill: "#1A1B43",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.69 58.86C81.3 58.29 71.98 45 60 45C57.93 45 55.93 45.41 54.05 46.07L57.29 49.31C58.18 49.12 59.08 49.01 60 49.01C68.05 49.01 75.14 56.99 77.54 60.01C76.62 61.17 75.01 63.06 72.92 64.94L75.76 67.78C79.3 64.56 81.51 61.41 81.69 61.14C82.16 60.46 82.16 59.55 81.69 58.87V58.86Z",
    fill: "#1A1B43",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.65 70.32L69.79 67.46L65.5 63.17L53.16 50.83L50.2 47.87L46.27 43.94C45.49 43.16 44.22 43.16 43.44 43.94C42.66 44.72 42.66 45.99 43.44 46.77L46.81 50.14C41.8 53.95 38.56 58.56 38.34 58.89C37.87 59.57 37.87 60.48 38.34 61.16C38.73 61.73 48.05 75.02 60.03 75.02C63.34 75.02 66.43 74 69.2 72.52L72.78 76.1C73.17 76.49 73.68 76.69 74.19 76.69C74.7 76.69 75.21 76.49 75.6 76.1C76.38 75.32 76.38 74.05 75.6 73.27L72.66 70.33L72.65 70.32ZM55.22 58.55L60.92 64.24C60.46 64.4 59.97 64.5 59.47 64.5C56.99 64.5 54.97 62.48 54.97 60C54.97 59.5 55.07 59.01 55.23 58.55H55.22ZM60 71C51.95 71 44.86 63.02 42.46 60C43.73 58.41 46.31 55.43 49.64 52.98L52.22 55.56C51.4 56.89 50.96 58.41 50.96 60.01C50.96 64.7 54.77 68.51 59.46 68.51C61.06 68.51 62.58 68.06 63.91 67.25L66.2 69.54C64.25 70.44 62.16 71.01 60 71.01V71Z",
    fill: "#1A1B43",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_3249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyPreview);
export default __webpack_public_path__ + "static/media/icon-empty-preview.d9878967006fccd5de3ae39580ecd1c2.svg";
export { ForwardRef as ReactComponent };